import RootService from "@services";
import * as queries from "./query";

export default new RootService({ queries });
